// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file base.proto (package org.callistovault.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_options } from "./options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file base.proto.
 */
export const file_base: GenFile = /*@__PURE__*/
  fileDesc("CgpiYXNlLnByb3RvEhRvcmcuY2FsbGlzdG92YXVsdC52MiIRCg9HZXRGbGFnc1JlcXVlc3QiggEKEEdldEZsYWdzUmVzcG9uc2USQAoFZmxhZ3MYASADKAsyMS5vcmcuY2FsbGlzdG92YXVsdC52Mi5HZXRGbGFnc1Jlc3BvbnNlLkZsYWdzRW50cnkaLAoKRmxhZ3NFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIiQKD0dldFRva2VuUmVxdWVzdBIRCglvcGVyYXRpb24YASABKAkiIQoQR2V0VG9rZW5SZXNwb25zZRINCgV0b2tlbhgBIAEoCTLXAQoLQmFzZVNlcnZpY2USYwoIR2V0RmxhZ3MSJS5vcmcuY2FsbGlzdG92YXVsdC52Mi5HZXRGbGFnc1JlcXVlc3QaJi5vcmcuY2FsbGlzdG92YXVsdC52Mi5HZXRGbGFnc1Jlc3BvbnNlIgiItRgBkLUYARJjCghHZXRUb2tlbhIlLm9yZy5jYWxsaXN0b3ZhdWx0LnYyLkdldFRva2VuUmVxdWVzdBomLm9yZy5jYWxsaXN0b3ZhdWx0LnYyLkdldFRva2VuUmVzcG9uc2UiCIi1GAGQtRgBQhlaF2NhbGxpc3RvdmF1bHQub3JnL3Byb3RvYgZwcm90bzM", [file_options]);

/**
 * @generated from message org.callistovault.v2.GetFlagsRequest
 */
export type GetFlagsRequest = Message<"org.callistovault.v2.GetFlagsRequest"> & {
};

/**
 * Describes the message org.callistovault.v2.GetFlagsRequest.
 * Use `create(GetFlagsRequestSchema)` to create a new message.
 */
export const GetFlagsRequestSchema: GenMessage<GetFlagsRequest> = /*@__PURE__*/
  messageDesc(file_base, 0);

/**
 * @generated from message org.callistovault.v2.GetFlagsResponse
 */
export type GetFlagsResponse = Message<"org.callistovault.v2.GetFlagsResponse"> & {
  /**
   * @generated from field: map<string, string> flags = 1;
   */
  flags: { [key: string]: string };
};

/**
 * Describes the message org.callistovault.v2.GetFlagsResponse.
 * Use `create(GetFlagsResponseSchema)` to create a new message.
 */
export const GetFlagsResponseSchema: GenMessage<GetFlagsResponse> = /*@__PURE__*/
  messageDesc(file_base, 1);

/**
 * @generated from message org.callistovault.v2.GetTokenRequest
 */
export type GetTokenRequest = Message<"org.callistovault.v2.GetTokenRequest"> & {
  /**
   * @generated from field: string operation = 1;
   */
  operation: string;
};

/**
 * Describes the message org.callistovault.v2.GetTokenRequest.
 * Use `create(GetTokenRequestSchema)` to create a new message.
 */
export const GetTokenRequestSchema: GenMessage<GetTokenRequest> = /*@__PURE__*/
  messageDesc(file_base, 2);

/**
 * @generated from message org.callistovault.v2.GetTokenResponse
 */
export type GetTokenResponse = Message<"org.callistovault.v2.GetTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message org.callistovault.v2.GetTokenResponse.
 * Use `create(GetTokenResponseSchema)` to create a new message.
 */
export const GetTokenResponseSchema: GenMessage<GetTokenResponse> = /*@__PURE__*/
  messageDesc(file_base, 3);

/**
 * BaseService provides simple APIs that don't easily cluster anywhere else.
 *
 * @generated from service org.callistovault.v2.BaseService
 */
export const BaseService: GenService<{
  /**
   * GetFlags returns a mapping of environment variables / database-defined flags that mutate frontend code.
   *
   * @generated from rpc org.callistovault.v2.BaseService.GetFlags
   */
  getFlags: {
    methodKind: "unary";
    input: typeof GetFlagsRequestSchema;
    output: typeof GetFlagsResponseSchema;
  },
  /**
   * GetToken returns a token that can be used to authorize a future request to some non-idempotent operation.
   *
   * @generated from rpc org.callistovault.v2.BaseService.GetToken
   */
  getToken: {
    methodKind: "unary";
    input: typeof GetTokenRequestSchema;
    output: typeof GetTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_base, 0);

